<script>
export default {
    about_us: {
        version: `Budget Control par MlabFactory s.r.l version `,
        personal_finance: `<b>Gestionnaire de finances personnelles</b><p>Budget Control par MlabFactory s.r.l est un outil de gestion des finances personnelles qui vous aide à suivre vos dépenses, afin que vous puissiez garder le contrôle et atteindre vos objectifs.</p>`,
        information: `<b>Informations sur Budget Control</b><p>MlabFactory s.r.l est un développeur professionnel basé en Italie, à Milan, qui opère et développe des applications depuis 2008. En savoir plus sur l'équipe</p><a href="http://mlabfactory.it">Mlabfactory.it</a>`,
        visit_our_website: 'Visitez notre site web',
    },
    assistance: {
        write_question: `<p>Écrivez votre question ici</p>`,
        thanks: `Merci pour votre demande. Nous vous répondrons dès que possible.`,
    },
    profile: {
        policy: `<p>En vous inscrivant ou en vous connectant avec l'un des services ci-dessus, vous acceptez nos <a class="font-bold text-decoration-line" href="https://www.budgetcontrol.cloud/terms/">Conditions d'utilisation</a> et reconnaissez notre <a class="font-bold text-decoration-line" href="https://www.budgetcontrol.cloud/privacy/">Politique de confidentialité</a>, qui décrit comment nous gérons vos données personnelles.</p>`
    },
    settings: {
        manage_your_workspace: 'Gérez vos espaces de travail.',
        manage_wallets: 'Gérez les portefeuilles, changez les icônes, la couleur.',
        manage_entry: 'Gérez vos catégories de revenus.',
        customize_entry: 'Personnalisez les étiquettes des revenus.',
        configure_model: 'Configurez les modèles de revenus.',
        set_currency: 'Définissez votre devise préférée.',
        edit_profile: 'Modifiez votre profil utilisateur.',
        learn: 'En savoir plus sur notre équipe.',
        write_us: 'Contactez-nous pour obtenir de l\'aide.',
    },
    install_app: 'Hey ! Voulez-vous installer l\'application ?',
    tooltips: {
        finalize: {
            workspace: "Le nom de votre espace de travail, afin de pouvoir l'identifier facilement si vous en créez plusieurs autres.",
            currency: "La devise par défaut que vous utilisez, par exemple l'euro.",
            wallet: "Le nom de votre premier portefeuille, par exemple cela peut aussi être le nom de votre banque.",
            balance: "Le solde initial de votre portefeuille.",
            payment_type: "Le moyen de paiement que vous utilisez le plus souvent, nous le rendrons par défaut.",
            wallet_type: "Quel type est votre portefeuille ? Une banque ou simplement du liquide ? Ici, vous pouvez le choisir pour améliorer vos statistiques."
        }
    }
}
</script>
